export default "__VITE_ASSET__BGl54Zh7__"